export const DEFAULT_TEMPLATE = "default"
export const STANDARD_TEMPLATE = "standard"
export const CUTAWAY_22_TEMPLATE = "cutaway22"
export const STRAIGHT_22_TEMPLATE = "straight22"
export const CLUB_22_TEMPLATE = "club22"
export const CLUB_25_TEMPLATE = "club25"
export const TAB_22_TEMPLATE = "tab22"
export const WING_25_TEMPLATE = "wing25"

export const TEMPLATE_HEADER_HEIGHTS = {
    // Values are in REM
    [DEFAULT_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.23,
            back_to_site_banner: 0,
        },
        lowerHeader: {
            mobile: 2.75,
            desktop: 2.75,
        },
        mobile_scrollHeight: 2.75,
    },
    [STANDARD_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.23,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 2.75,
            desktop: 2.75,
        },
        mobile_scrollHeight: 2.75,
    },
    [STRAIGHT_22_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 0,
            desktop: 2.75,
        },
        mobile_scrollHeight: 0,
    },
    [TAB_22_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 0,
            desktop: 2.75,
        },
        mobile_scrollHeight: 0,
    },
    [WING_25_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 0,
            desktop: 0,
        },
        mobile_scrollHeight: 0,
    },
    [CLUB_22_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 2.75,
            desktop: 2.75,
        },
        mobile_scrollHeight: 2.75,
    },
    [CUTAWAY_22_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 1.5,
        },
        lowerHeader: {
            mobile: 2.75,
            desktop: 2.313,
        },
        mobile_scrollHeight: 2.75,
    },
    [CLUB_25_TEMPLATE]: {
        upperHeader: {
            desktop: 3.75,
            desktop_staticHeaderBanner: 6,
            mobile: 2.75,
            mobile_staticHeaderBanner: 2.75,
            mobile_banner_offset: 2.25,
            back_to_site_banner: 0,
        },
        lowerHeader: {
            mobile: 2.75,
            desktop: 2.75,
        },
        mobile_scrollHeight: 2.75,
    },
}

export const DEFAULT_TEMPLATE_HEADER_HEIGHTS = {
    mobile: 2.75,
    desktop: 3.5,
    mobile_scrollHeight: 2.75,
}

export const SECURE_HEADER_HEIGHTS = {
    mobile: 2.75,
    desktop: 3.75,
    mobile_scrollHeight: 0,
}
